import { createContext, useContext } from 'react'
import type { FeatureFlagKey } from './registry'

export type FeatureFlagValues = Readonly<Record<FeatureFlagKey, boolean>>
export type FeatureFlagContextValue = Readonly<{
  values: FeatureFlagValues
}>

export const FeatureFlagsContext = createContext<FeatureFlagContextValue | undefined>(undefined)

export function useFeatureFlag(key: FeatureFlagKey): boolean {
  const context = useContext(FeatureFlagsContext)
  if (context === undefined) {
    throw new Error('useFeatureFlag must be used within FeatureFlagsProvider.')
  }
  return context.values[key]
}
